import React from 'react';
import { WhatsappLogo } from '@phosphor-icons/react';
import { useLocation, useParams } from 'react-router-dom';

const WHATSAPP_NUMBER = '27620845006'; // 062 084 5006 in international format

const WhatsAppWidget = () => {
  const location = useLocation();
  // Hide on home page
  if (location.pathname === '/') return null;
  
  // Determine message based on route
  const isPlanDetail = /^\/plans\/[^/]+$/.test(location.pathname);
  const message = isPlanDetail ? 'Is this plan right for my stand?' : 'Help me choose';
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
  
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 flex items-center space-x-2 bg-[#25D366] text-white px-4 py-3 rounded-full shadow-lg hover:bg-[#20BD5A] transition-all hover:scale-105"
      data-testid="whatsapp-widget"
      aria-label="Chat on WhatsApp"
    >
      <WhatsappLogo size={28} weight="fill" />
      <span className="hidden sm:inline text-sm font-bold">Chat</span>
    </a>
  );
};

export default WhatsAppWidget;
